import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import axiosInstance from '../../utils/axiosInstance';

const Footer = () => {
  const [categories, setCategories] = useState([]);

  // 1. Fetch categories (Logic Unchanged)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axiosInstance.get('/categories');
        // Sort by sequence
        setCategories(data.sort((a, b) => a.sequence - b.sequence));
      } catch (error) {
        console.error("Failed to fetch categories for footer:", error);
      }
    };
    fetchCategories();
  }, []);

  // 2. Split categories (Logic Unchanged)
  const quickLinkCategories = categories.slice(0, 4);
  const importantLinkCategories = categories.slice(4, 9);

  return (
    <footer className="bg-[#2a0b2b] text-[#EBE6DE] py-16 px-4 font-sans">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          
          {/* Brand Section */}
          <div className="md:col-span-1">
            <span className="font-serif text-2xl font-bold tracking-widest text-[#CAB273] block mb-6">
              AfrinJewelry
            </span>
            <p className="text-sm opacity-60 leading-relaxed">
              Welcome to Our Blog, where we share interesting articles, tutorials, and the latest updates in style and luxury.
            </p>
          </div>

          {/* Quick Links Section (Dynamic Categories 1-4) */}
          <div>
            <h4 className="uppercase tracking-widest text-xs font-bold text-[#CAB273] mb-6">Quick Links</h4>
            <ul className="space-y-4 text-sm opacity-80">
              <li><FooterLink to="/" text="Home" /></li>
              <li><FooterLink to="/blogs" text="Articles" /></li>
              {quickLinkCategories.map(cat => (
                <li key={cat.id}>
                  <FooterLink to={`/blogs?category=${cat.id}`} text={cat.name} />
                </li>
              ))}
            </ul>
          </div>

          {/* Important Links Section (Dynamic Categories 5-9) */}
          <div>
            <h4 className="uppercase tracking-widest text-xs font-bold text-[#CAB273] mb-6">Discover</h4>
            <ul className="space-y-4 text-sm opacity-80">
              {importantLinkCategories.map(cat => (
                <li key={cat.id}>
                  <FooterLink to={`/blogs?category=${cat.id}`} text={cat.name} />
                </li>
              ))}
              <li><FooterLink to="/about" text="About Us" /></li>
              <li><FooterLink to="/contact" text="Contact" /></li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div>
            <h4 className="uppercase tracking-widest text-xs font-bold text-[#CAB273] mb-6">Social</h4>
            {/* Keeping your original icons, but styled to match the theme */}
            <div className="flex gap-4">
              <SocialLink href="https://facebook.com" icon={<FaFacebook size={20} />} />
              <SocialLink href="https://twitter.com" icon={<FaTwitter size={20} />} />
              <SocialLink href="https://instagram.com" icon={<FaInstagram size={20} />} />
              <SocialLink href="https://linkedin.com" icon={<FaLinkedin size={20} />} />
            </div>
            <p className="mt-6 text-xs opacity-40">
                Follow us for the latest trends and exclusive offers.
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-16 pt-8 border-t border-[#EBE6DE]/10 text-center text-xs opacity-40">
          <p>&copy; {new Date().getFullYear()} AfrinJewelry. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

// Helper: Removed Chevron to match the clean luxury style of the new design
// Added hover color change to Gold (#CAB273)
const FooterLink = ({ to, text }) => (
  <Link to={to} className="hover:text-[#CAB273] transition-colors duration-300 block">
    {text}
  </Link>
);

// Helper: Updated Social Link to match theme
const SocialLink = ({ href, icon }) => (
  <a 
    href={href} 
    target="_blank" 
    rel="noopener noreferrer" 
    className="bg-[#EBE6DE]/5 p-2 rounded-full hover:bg-[#CAB273] hover:text-[#2a0b2b] text-[#EBE6DE] transition-all duration-300"
  >
    {icon}
  </a>
);

export default Footer;